import React from 'react';
import styled from 'styled-components';
import { useEffect } from 'react';
import { useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { prodClipAddAction, prodClipAction, userClipAction, userClipProductAction, userClipInfoAction, setDefautlValueProductAction} from '../../modules/su/userInfoModule';
import Modal from 'react-modal';
import NormalPopup, { customModalStyles } from '../common/popup/NormalPopup';
import SelectClipProd from '../common/button/SelectClipProd';
import SpanPrice from '../common/price/SpanPrice'
import { forEach, remove } from 'lodash';
import { setUserProdDelAction, setUserProdDelAllAction } from '../../modules/su/userProdModule';
import { isIE, isChrome, isMobileOnly } from "react-device-detect";

const MyClipProdBlock = styled.div`
  .best_item-list .best_item,
  .best_item-list li {
    float: left;
    width:${isMobileOnly?"44vw":"25%"};
    ${isMobileOnly?`

  `:`
    height: 386px;
  `};
    
    margin-top: 40px;
    padding-left: ${isMobileOnly?"0":"28px"};
  }

  .ed-back-dim {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    border-radius: 4px;
    //opacity: 0;
    -webkit-transition: opacity 0.3s;
    -o-transition: opacity 0.3s;
    transition: opacity 0.3s;
    overflow: hidden;
  }
  .ed-back-dim a {
    display: block;
    width: 100%;
    height: 100%;
    color: #fff;
    background-color: rgba(17, 17, 17, 0.65);
    font-size: 18px;
    font-weight: 400;
  }
  .ed-back-dim a span {
    display: block;
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    width: 100%;
    padding: 0 5px;
    text-align: center;
  }
`;

const MyClipProdHomeLinkBlock = styled.div`
    float: left;
    ${isMobileOnly?`
    width: 40vw;
  `:`
    width: 227px;
  `};
    
    height: 40px;
    padding: 11px 13px 10px;
    margin-right: 8px;
    margin-left : 34px;
    margin-top: 10px;
    margin-bottom: 10px;
    color: #fff;
    //background-color: #111; //#bbb
    background-color: ${prods => prods.active ? '#111' : '#bbb'};
    cursor : ${prods => prods.active ? 'pointer' : 'default'};
    pointer-events : ${prods => prods.active ? 'auto' : 'none'};
    text-align: center;
    font-size: 14px;
    display: inline-block;
    border-radius: 4px;

    ::after {
        content: '';
        display: inline-block;
        width: 7px;
        height: 11px;
        margin-left: 10px;
        background: url(/assets/images/icon/btn_arrow-icon.png) center center/cover no-repeat;
        -webkit-transform: rotate(360deg);
        -ms-transform: rotate(360deg);
        transform: rotate(360deg);
    }    
`;

const MyClipProdListUlBlock = styled.ul`
    ${isMobileOnly?`
    /* display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox; */
    display: flex;
    /* -webkit-flex-wrap: wrap;
    -ms-flex-wrap: wrap; */
    flex-wrap: wrap;
    margin-bottom: 40px;
    margin-left: 0px;
    /* -webkit-box-pack: space-between;
    -webkit-justify-content: space-between;
    -ms-flex-pack: space-between; */
    justify-content: space-between;
  `:`
   
  `};

`;

const DEFAULT_DISP_CNT = 12;
const MORE_DISP_CNT = 8;
const VIEW_ALL = {brnd_id: 0, brnd_han: "전체보기", countprdt:0 };

const MyClipProd = ({ clipinfo }) => {

    const dispatch = useDispatch();
    const history = useHistory();

    const [openModal, setOpenModal] = useState(false);
    const [msg, setMsg] = useState(null);
    const [productId, setProductId] = useState(null);
    const [brandId, setBrandId] = useState(null);

    const [addView, setAddView] = useState(false);
    const [scrollPostion, setScrollPostion] = useState({ heignt: 0, isClick: false });

    const { email, clipProd, sort, prodClipResult, defaultValueProduct } = useSelector(
        ({ userReducer, userInfoReducer, userProdReducer }) => ({
            email: userReducer.id,
            clipProd: userInfoReducer.clipProd,
            prodClipResult: userProdReducer.prodClipResult,
            sort: userInfoReducer.sort,
            defaultValueProduct: userInfoReducer.defaultValueProduct
        })
    );

    useEffect(() => {
        if (clipProd === null && clipinfo !== null) {
            dispatch(prodClipAction(email, 0, 0, DEFAULT_DISP_CNT));
        }

        return () => {
        };

    }, []);

    useEffect(() => {

        if (scrollPostion.heignt > 0 && scrollPostion.isClick) {
            window.scrollTo(0, scrollPostion.heignt);
        }
        if (clipProd !== null && clipinfo !== null) {
            let count = 0;
            if(defaultValueProduct.brnd_id === 0){
                for(var i = 0; i < clipinfo.prodbrand.length ; i++){
                    count += clipinfo.prodbrand[i].countprdt;
                }
            }
            else {
                let index = clipinfo.prodbrand.findIndex(x => x.brnd_id === defaultValueProduct.brnd_id);
                count += clipinfo.prodbrand[index].countprdt;
            }

            if (clipProd.length < count) {
                setAddView(true);
            }
            else {
                setAddView(false);
            }
        }
        setScrollPostion({ heignt: 0, isClick: false });

        return () => {
        };

    }, [clipProd]);

    useEffect(() => {

        if(prodClipResult){
            if (msg === '삭제하시겠습니까?') {
                let index = clipinfo.prodbrand.findIndex(x => x.brnd_id === brandId);
                let count = clipinfo.prodbrand[index].countprdt - 1;

                if(count === 0){
                    dispatch(userClipAction('sort=' + sort));
                    //setDefaultValue(VIEW_ALL);
                    dispatch(setDefautlValueProductAction(VIEW_ALL));
                }
                else {
                    //clipinfo.prodbrand[index].countprdt = count;
                    let clipSum = [...clipProd];
                    remove(clipSum, (obj) => { return obj.prdct_id === productId })
                    let clip = Object.assign({}, clipinfo);
                    clip.prodbrand[index].countprdt = count;
                    dispatch(userClipProductAction(clipSum));
                    dispatch(userClipInfoAction(clip));
                }
                setMsg(null);
            } else if(msg === '전체 삭제하시겠습니까?'){
                    dispatch(userClipAction('sort=' + sort));
                    //setDefaultValue(VIEW_ALL);
                    dispatch(setDefautlValueProductAction(VIEW_ALL));
                    setMsg(null);
            }
        }

        return () => {
        };

    }, [prodClipResult]);

    const onClickAddView = () => {
        //dispatch(getBrandInfoAction(BrFilterList[index].value,"0","0"));
        let count = 0;
        if(defaultValueProduct.brnd_id === 0){
            for(var i = 0; i < clipinfo.prodbrand.length ; i++){
                count += clipinfo.prodbrand[i].countprdt;
            }
        }
        else {
            let index = clipinfo.prodbrand.findIndex(x => x.brnd_id === defaultValueProduct.brnd_id);
            count += clipinfo.prodbrand[index].countprdt;
        }

        if (count > clipProd.length) {
            dispatch(prodClipAddAction(email, defaultValueProduct.brnd_id, clipProd.length, MORE_DISP_CNT));
        }

        setScrollPostion({ heignt: window.scrollY, isClick: true });
    }

    const getNoBrandContents = () => {
        return (
            <div className="none_item">
                <span style={{width:'fit-content'}}>내가 클립한 상품이 없어요 :-(</span>
            </div>
        )
    }

    const handleClickProduct = (prdct_id) => {
        history.push("/prod?prodid=" + prdct_id)
    }

    // 컨텐츠 정보
    const getProdContents = (target) => {
        if (target.length === 0) {
            return getNoBrandContents();
        } else {
            return (<div className="margin_t-30">
                {isMobileOnly ?
                <MyClipProdListUlBlock className="best_item-list margin_b-40 clearfix">
                {
                    target.map((curitem, index) => {
                        if(curitem.sell_status === "020102"){
                            return (
                                <li key={curitem.prdct_id} style = {{width:'44vw', padding:"0px", marginTop: '0px', marginBottom: '40px'}}>
                                    <div className="big_best-item" onClick = {() => { handleClickProduct(curitem.prdct_id) }}
                                    style={{ cursor: 'pointer', height : '44vw' }}>
                                        <p className="ed-front" style = {{height : '44vw', lineHeight:'44vw'}}>
                                            <img src={curitem.repr_img} style = {{width:'44vw', maxHeight:"44vw", verticalAlign: 'middle'}}/>
                                        </p>
                                        <div className="ed-back">
                                            <a>
                                                <span>{curitem.cate_name}</span>
                                            </a>
                                        </div>
                                    </div>
                                    <span className="bi-brand" onClick = {() => { handleClickProduct(curitem.prdct_id) }}
                                        style={{ cursor: 'pointer', height:'1.0em', overflow:'hidden' }}>
                                    {curitem.brnd_han}
                                    </span>
                                    <p className="product_title" onClick = {() => { handleClickProduct(curitem.prdct_id) }}
                                        style={{ cursor: 'pointer', height:'2.8em', overflow:'hidden' }}>
                                            {curitem.prdct_nm}
                                    </p>
                                    <SpanPrice value={curitem.sale_price} isSale={false} onClick = {() => { handleClickProduct(curitem.prdct_id) }} style={{ cursor: 'pointer' }}/>
                                    {
                                        curitem.sale_price === curitem.prdct_price ? '' :
                                            <SpanPrice value={curitem.prdct_price} isSale={true}onClick = {() => { handleClickProduct(curitem.prdct_id) }} style={{ cursor: 'pointer' }} />
                                    }
                                    <button type="button" className="tag_s-delete pop_open"
                                            onClick={() => { handleClickDelBtn(curitem.prdct_id, curitem.brnd_id) }}></button>
                                </li>
                            )
                        } else {
                            return (
                                <li key={curitem.prdct_id} style = {{width:'44vw', padding:"0px", marginTop: '0px', marginBottom: '40px',color: '#bbbbbb'}}>
                                    <div className="big_best-item"
                                    style={{ cursor: 'pointer', height : '44vw' }}>
                                        <p className="ed-front" style = {{height : '44vw', lineHeight:'44vw'}}>
                                            <img src={curitem.repr_img} style = {{width:'44vw', maxHeight:"44vw", verticalAlign: 'middle'}}/>
                                        </p>
                                        <div className="ed-back-dim">
                                            <a>
                                                <span>품절</span>
                                            </a>
                                        </div>
                                    </div>
                                    <span className="bi-brand" 
                                        style={{ cursor: 'pointer', height:'1.0em', overflow:'hidden' }}>
                                    {curitem.brnd_han}
                                    </span>
                                    <p className="product_title" 
                                        style={{ cursor: 'pointer', height:'2.8em', overflow:'hidden' }}>
                                            {curitem.prdct_nm}
                                    </p>
                                    <SpanPrice value={curitem.sale_price} isSale={false} isDim={true}/>
                                    {
                                        curitem.sale_price === curitem.prdct_price ? '' :
                                            <SpanPrice value={curitem.prdct_price} isSale={true} isDim={true}/>
                                    }
                                    <button type="button" className="tag_s-delete pop_open"
                                            onClick={() => { handleClickDelBtn(curitem.prdct_id, curitem.brnd_id) }}></button>
                                </li>
                            )
                        }
                        
                    })
                }
                {isMobileOnly ? <li style={{height:'0px', margin: '0px'}}></li> : ''}
                </MyClipProdListUlBlock>
                :
                <MyClipProdListUlBlock className="best_item-list margin_b-40 clearfix">
                    {
                        target.map((curitem, index) => {
                            if(curitem.sell_status === "020102"){
                                return (
                                    <li key={curitem.prdct_id}>
                                        <div className="big_best-item" onClick = {() => { handleClickProduct(curitem.prdct_id) }} style={{ cursor: 'pointer' }}>
                                            <div className="ed-front">
                                                <p className="ed-front" style = {{height : '213px', lineHeight:'213px'}}>
                                                <img src={curitem.repr_img} style = {{width : '213px', maxHeight:"213px", verticalAlign: 'middle', objectFit: 'cover', objectPosition: 'center center'}}/>
                                                </p>
                                            </div>
                                            <div className="ed-back">
                                                <a>
                                                    <span>{curitem.cate_name}</span>
                                                </a>
                                            </div>
                                        </div>
                                        <span className="bi-brand" onClick = {() => { handleClickProduct(curitem.prdct_id) }} style={{ cursor: 'pointer' }}>
                                        {curitem.brnd_han}
                                        </span>
                                        <p className="product_title" onClick = {() => { handleClickProduct(curitem.prdct_id) }} style={{ cursor: 'pointer' }}>
                                                {curitem.prdct_nm}
                                        </p>
                                        <SpanPrice value={curitem.sale_price} isSale={false} onClick = {() => { handleClickProduct(curitem.prdct_id) }} style={{ cursor: 'pointer' }}/>
                                        {
                                            curitem.sale_price === curitem.prdct_price ? '' :
                                                <SpanPrice value={curitem.prdct_price} isSale={true}onClick = {() => { handleClickProduct(curitem.prdct_id) }} style={{ cursor: 'pointer' }} />
                                        }
                                        <button type="button" className="tag_s-delete pop_open"
                                                onClick={() => { handleClickDelBtn(curitem.prdct_id, curitem.brnd_id) }}></button>
                                    </li>
                                ) 
                            }
                            else {
                                return (
                                    <li key={curitem.prdct_id} style={{ color: '#bbbbbb' }}>
                                        <div className="big_best-item" style={{ cursor: 'pointer' }}>
                                            <div className="ed-front">
                                                <p className="ed-front" style = {{height : '213px', lineHeight:'213px'}}>
                                                <img src={curitem.repr_img} style = {{width : '213px', maxHeight:"213px", verticalAlign: 'middle', objectFit: 'cover', objectPosition: 'center center'}}/>
                                                </p>
                                            </div>
                                            <div className="ed-back-dim">
                                                <a>
                                                    <span>품절</span>
                                                </a>
                                            </div>
                                        </div>
                                        <span className="bi-brand" style={{ cursor: 'pointer' }}>
                                        {curitem.brnd_han}
                                        </span>
                                        <p className="product_title" style={{ cursor: 'pointer' }}>
                                                {curitem.prdct_nm}
                                        </p>
                                        <SpanPrice value={curitem.sale_price} isSale={false}  style={{ cursor: 'pointer' }} isDim={true}/>
                                        {
                                            curitem.sale_price === curitem.prdct_price ? '' :
                                                <SpanPrice value={curitem.prdct_price} isSale={true}style={{ cursor: 'pointer' }} isDim={true} />
                                        }
                                        <button type="button" className="tag_s-delete pop_open"
                                                onClick={() => { handleClickDelBtn(curitem.prdct_id, curitem.brnd_id) }}></button>
                                    </li>
                                )
                            }
                            
                        })
                    }
                </MyClipProdListUlBlock>
                }

                {
                    addView === false ? '' :
                        <div className="text_center">
                            <button className="underline-btn" onClick={onClickAddView}>더보기</button>
                        </div>
                }
            </div >)
        }
    }

    const handleAllDelete = () => {
        setMsg("전체 삭제하시겠습니까?");
        // 팝업 표시
        setOpenModal(true);
    }

    // Delete 처리
    const handleClickDelBtn = (prdctid, brandid) => {
        setMsg("삭제하시겠습니까?");
        setOpenModal(true);
        setProductId(prdctid);
        setBrandId(brandid);
    }

    const handleModalClose = () => {
        setOpenModal(false);
    }

    // 확인
    const handleModalBtn1Click = () => {
        setOpenModal(false);
        if (msg === '삭제하시겠습니까?') {
            dispatch(setUserProdDelAction(email, productId));

        } else {
            dispatch(setUserProdDelAllAction(email, defaultValueProduct.brnd_id));
        }
    }

    // 닫기
    const handleModalBtn2Click = () => {
        setOpenModal(false);
    }

    const getDefaultValue = () => {
        return defaultValueProduct
    }

    const onChangeValue = (param) =>{
        if(param.brnd_id === defaultValueProduct.brnd_id){
            return;
        }

        dispatch(setDefautlValueProductAction(param));
        dispatch(prodClipAction(email, param.brnd_id, 0, DEFAULT_DISP_CNT));
    }

    const getOptions = () => {
        let Options = [VIEW_ALL];
        forEach(clipinfo.prodbrand, (curitem, idx) => {
            Options.push(curitem);
        })

        return Options;
    }

    if(clipinfo === null || clipProd === null || clipProd === undefined){
        return <div/>
    }

    if(clipinfo !== null && clipProd !== null && clipProd.length === 0){
        return getNoBrandContents();
    }
    return (
        <MyClipProdBlock>
            {isMobileOnly?
            <div>
                <div className="filter-top clearfix">
                    <div className = "f-left">
                    <SelectClipProd
                        valueDefault={getDefaultValue()}
                        options={getOptions()}
                        onChange={onChangeValue} />
                    <Link to={"/brHome/"+defaultValueProduct.brnd_id}>
                            <MyClipProdHomeLinkBlock active = {defaultValueProduct.brnd_id > 0 ? true: false}>
                                        BRAND HOME
                            </MyClipProdHomeLinkBlock>
                    </Link>
                    </div>

                </div>
                <div style = {{height:'30px'}}>
                    <div className="f-right clearfix">
                        <button type="button" className="mp_text-btn f-left margin_t-10 pop_open"
                            onClick={handleAllDelete}>전체삭제</button>
                    </div>
                </div>
            </div>
            :
            <div className="filter-top clearfix">
                <div className = "f-left">
                <SelectClipProd
                    valueDefault={getDefaultValue()}
                    options={getOptions()}
                    onChange={onChangeValue} />
                <Link to={"/brHome/"+defaultValueProduct.brnd_id}>
                        <MyClipProdHomeLinkBlock active = {defaultValueProduct.brnd_id > 0 ? true: false}>
                                    BRAND HOME
                        </MyClipProdHomeLinkBlock>
                </Link>
                </div>

                <div className="f-right clearfix">
                    <button type="button" className="mp_text-btn f-left margin_t-10 pop_open" style={{ marginTop: '20px' }}
                        onClick={handleAllDelete}>전체삭제</button>
                </div>
            </div>
            }

            {getProdContents(clipProd)}
            <Modal
                isOpen={openModal}
                onRequestClose={handleModalClose}
                style={customModalStyles}
                onAfterOpen={() => document.body.style.overflow = 'hidden'}
                onAfterClose={() => document.body.removeAttribute('style')}>
                {
                    <NormalPopup
                        text=""
                        text2={msg}
                        btn1="확인" btn2="취소"
                        onClick1={handleModalBtn1Click}
                        onClick2={handleModalBtn2Click} />
                }

            </Modal>

        </MyClipProdBlock>
    );
};

export default MyClipProd;
